import React, { memo } from 'react';

const MapMarkSmall = memo(({ size = 14 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00061 7.5362C8.01221 7.5362 8.83228 6.73181 8.83228 5.73954C8.83228 4.74727 8.01221 3.94287 7.00061 3.94287C5.98901 3.94287 5.16895 4.74727 5.16895 5.73954C5.16895 6.73181 5.98901 7.5362 7.00061 7.5362Z"
        stroke="#5A5A5A"
        strokeMiterlimit="10"
      />
      <path
        d="M7.00016 1.1665C4.42183 1.1665 2.3335 3.214 2.3335 5.73984C2.3335 8.26567 5.00516 10.9023 7.00016 12.8332C8.99516 10.9023 11.6668 8.26567 11.6668 5.73984C11.6668 3.214 9.5785 1.1665 7.00016 1.1665Z"
        stroke="#5A5A5A"
        strokeMinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default MapMarkSmall;
